import React, { createContext, useState } from 'react';

import { TBannerProps } from '@riac/design-system';

export type GlobalBannerContextValue = {
  banners: Record<string, BannerData>,
  addBanner: (bannerData: BannerData, bannerId: string) => void,
  removeBanner: (bannerId: string) => void,
};

export const GlobalBannerContext = createContext<GlobalBannerContextValue>({} as any);

type BannerData = TBannerProps;
export const GlobalBannerContextProvider = ({children}): JSX.Element => {
  const [banners, setBanners] = useState<Record<string, BannerData>>({});

  const addBanner = (bannerData: BannerData, bannerId: string) => {
    setBanners((prev) => Object.assign({}, prev, {[bannerId]: bannerData}));
  };

  const removeBanner = (bannerId: string): void => {
    setBanners((prev) => {
      const next = Object.assign({}, prev);
      delete next[bannerId];

      return next;
    });
  };

  return (
    <GlobalBannerContext.Provider
      value = {{
        banners,
        addBanner,
        removeBanner,
      }}
    >
      {children}
    </GlobalBannerContext.Provider>
  );
}
